import { Box, Skeleton } from '@chakra-ui/react';
import { FC, useState, CSSProperties } from 'react';

interface Props {
  src: string;
  width?: string | number;
  height?: string | number;
  allow?: string;
  allowFullScreen?: boolean;
  style?: CSSProperties;
}

const IframeWithSkeleton: FC<Props> = ({
  src,
  width = '100%',
  height = '405',
  allow,
  allowFullScreen,
  style,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const iframeStyle: CSSProperties = {
    border: 'none',
    borderRadius: '12px',
    maxWidth: '100%',
    display: isLoaded ? 'block' : 'none',
    ...style,
  };

  return (
    <Box position="relative" width={width} maxW="100%">
      {!isLoaded && (
        <Skeleton
          borderRadius="12px"
          width="100%"
          height={height}
        />
      )}
      <Box
        as="iframe"
        src={src}
        width="100%"
        height={height}
        allow={allow}
        allowFullScreen={allowFullScreen}
        style={iframeStyle}
        onLoad={() => setIsLoaded(true)}
      />
    </Box>
  );
};

export default IframeWithSkeleton;
